export default __webpack_public_path__ + "static/media/drone-yellow.77c75eb2.png";